import CancelOutlined from "@mui/icons-material/CancelOutlined"
import { Button, Table, Tag, Tooltip } from "antd"
import { error_manager } from "helper/error_manager"
import { post } from "helper/request"
import { Component } from "react"
import { connect } from "react-redux"
import { CasePriority } from "utils/const"
import { getCaseIdPlaceholder } from "utils/org_utils"
import { openEndPoint } from "utils/utils"

import "asset/style/custom_antd_table_style.css"


class CaseTable extends Component {
    constructor(props) {
        super(props)
    }

    columns = [
        {
            title: getCaseIdPlaceholder(),
            key: "case_id",
            dataIndex: "case_id",
            defaultSortOrder: "ascend",
            sorter: (a, b) => a.case_id_str.localeCompare(b.case_id_str),
        },
        {
            title: "Patient Name",
            key: "patient_name",
            dataIndex: "patient_name",
        },
        {
            title: "Created On",
            key: "date",
            dataIndex: "date",
            defaultSortOrder: "descend",
            sorter: (a, b) => a.date_parsed - b.date_parsed,
        },
        {
            title: "Status",
            key: "case_status",
            dataIndex: "case_status",
            render: (data) => <Tag>{data}</Tag>,
            filters: [...(new Set(this.props.cases?.map(({ case_status }) => case_status)))]?.map(v => ({ "text": v, "value": v })),
            onFilter: (value, record) => record.case_status === value,
        },
        {
            title: "Priority",
            key: "priority",
            dataIndex: "priority",
            render: (data) => <Tag>{data}</Tag>,
            defaultSortOrder: "ascend",
            sorter: (a, b) => a.priority_rank - b.priority_rank,
        },
        {
            title: "Assigned Users",
            key: "assigned_users",
            dataIndex: "assigned_users",
            render: (data) => <>{data.map(username => <Tag>{username}</Tag>) || []}</>,
            filters: [...new Set(this.props.cases?.map(({ assigned_users }) =>
                assigned_users?.map(({ username }) => username)
            )
                ?.reduce((p, c) => [...p, ...c], []))]
                ?.map(v => ({ "text": v, "value": v })),
            onFilter: (value, record) => record.assigned_users?.includes(value),
        },
        {
            title: "Actions",
            key: "actions",
            dataIndex: "case_id",
            render: (case_id) => (
                <Button
                style={{ display: "flex", padding: 0, alignItems: "center" }}
                onClick={(e) => {
                    e.stopPropagation()
                    this.removeCase(case_id)
                }}>
                    <Tooltip title="Remove Case from folder">
                        <CancelOutlined style={{ padding: 0, color: "#ebebeb" }} />
                    </Tooltip>
                </Button>
            )
        }
    ]

    removeCase = (case_id) => {
        const url = "/api/update_cases_in_folder/"
        const data = { case_ids: [case_id], folder_id: this.props.folderId, action: "remove" }

        post(url, data)
            .catch(err => error_manager("unable to remove case", err))
            .finally(() => window.location.reload())
    }

    getData = () => this.props.cases?.map(d => ({
        id: d["id"],
        case_id: d["case_id"],
        case_id_str: d["case_id"]?.toString()?.toLowerCase(),
        patient_name: d["patient_name"],
        date_parsed: Date.parse(d["date"]),
        date: (new Date(Date.parse(d["date"]))).toDateString(),
        case_status: d["case_status"],
        priority: d["priority"],
        priority_rank: CasePriority.find(({ label }) => label?.toLowerCase() === d["priority"]?.toLowerCase())?.rank || Number.MAX_SAFE_INTEGER,
        assigned_users: d["assigned_users"]?.map(({ username }) => username),
    })) || []

    paginationConfig = () => ({
        pageSize: 12,
        total: this.props?.cases?.length,
    })

    render() {
        return (
            <Table
                className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                rowClassName="slide-table-rows "
                columns={this.columns}
                dataSource={this.getData() || []}
                onRowClick={(record, idx) => openEndPoint(`/case/${record.id}`)}
                pagination={this.paginationConfig()}
            />
        )
    }
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps)(CaseTable)